module.exports = __webpack_public_path__ + "media/sub4-3.65916ac8.mp4";